import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LambdaService {
  constructor(private http: HttpClient) {}

  async invokeSendPaymentsData(customerId: string, recaptchaToken: string) {
    let response = await this.http.post(`${environment.lambdaUrls.sendPaymentsData}`, { customerId, recaptchaToken }).toPromise() as any;
    if (response && typeof response === 'string') {
      response = JSON.parse(response);
    }
    return response;
  }

  async invokeGetOrders(customerTaxId: string, recaptchaToken: string) {
    const response = await this.http.post(`${environment.lambdaUrls.getOrders}`, { customerTaxId, recaptchaToken }).toPromise() as any;
    if (response && response && typeof response.body === 'string') {
      response.body = JSON.parse(response.body);
    }
    return response.body;
  }
}
